import { HeadTitle, MenuItem, Spacer, MenuBottomsheet } from 'oui';
import { SideBox } from '../../etc/LBox/LBox';
import { useOutletContext } from 'react-router-dom';
import { useMtgNum } from '../../../application/bloc/useMtgNum';

export const MtgNum = () => {
  const {
    mappedCodeList,
    navigate,
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    saveInputInfoTemp,
  }: any = useOutletContext();
  const { sendBeaconClkBtnOption } = useMtgNum();

  const getDefaultValue = () => {
    if (mortgageInfo.haveCnt.value) {
      if (mortgageInfo.haveCnt.value === '30') return {};
      else {
        let temp =
          mortgageInfo.haveCnt.value === '10' ? 'firstYn' : 'disposalPlanYn';
        return mappedCodeList[`C049${mortgageInfo.haveCnt.value}`].filter(
          (item: any) => item.value === mortgageInfo[temp].value,
        )[0];
      }
    } else {
      return {};
    }
  };
  // todo 저장 로직 수정
  const handleChangeNum = (item: any) => {
    onChangeWrappingInput({
      key: mortgageInfo.haveCnt.value === '10' ? 'firstYn' : 'disposalPlanYn',
      text: item.text,
      value: item.value,
    });
    saveInputInfoTemp();
    navigate('/mtg/conditions/3', {
      state: { ref_page: '/conditions/2' },
      replace: true,
    });
    sendBeaconClkBtnOption({
      btmsheet_name: selectSheet.title,
      option_name: item.text,
      before_option_name: getDefaultValue()?.text ?? '',
    });
  };

  const onClickMenuItem = (item: any) => {
    if (mortgageInfo?.haveCnt?.value !== item.value) {
      if (mortgageInfo?.haveCnt?.value) {
        onChangeWrappingInput({
          key: item.value === '10' ? 'firstYn' : 'disposalPlanYn',
          value: '',
        });
      }

      onChangeWrappingInput({
        key: 'haveCnt',
        text: item.text,
        value: item.value,
      });
    }

    openSelectSheet(`C049${item.value}`);
    sendBeaconClkBtnOption({
      btmsheet_name: '',
      option_name: item.text,
      before_option_name: mortgageInfo.haveCnt.text ?? '',
    });
  };
  return (
    <>
      <HeadTitle textTitle={'보유 중인 주택 수를 선택해 주세요'} />
      <Spacer size={'sm'} />
      <SideBox>
        {mappedCodeList?.C049?.filter((item: any, idx: any) => {
          if (item.value === '10') {
            if (mortgageInfo.purposeCd.value === '10') return true;
            else return false;
          } else {
            return true;
          }
        }).map((item: any, idx: any) => {
          return (
            <MenuItem
              key={`${item.text}_${idx}`}
              text={item.text}
              value={item.value}
              isSelected={mortgageInfo?.haveCnt.text === item.text}
              subText={item.text !== item.desc && item.desc}
              state={
                mortgageInfo?.haveCnt.text === item.text ? 'focused' : 'enabled'
              }
              onSelectMenuItem={() => {}}
              onClickMenuItem={() => onClickMenuItem(item)}
            />
          );
        })}
      </SideBox>

      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          handleChangeNum(e);
          selectSheet.onClose();
        }}
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={getDefaultValue()}
      />
    </>
  );
};
